import { sortCollectionItems } from "../../../shared/lib/sort/sortCollectionItems.js";
function formatEquipmentGroups(options) {
  const groupMap = /* @__PURE__ */ new Map();
  options.forEach((option) => {
    const optionGroup = option.group;
    const group = groupMap.get(option.group.name);
    if (!optionGroup.id) {
      return;
    }
    if (!group) {
      groupMap.set(optionGroup.name, {
        group: optionGroup,
        options: [option]
      });
      return;
    }
    group.options.push(option);
  });
  const groups = Array.from(groupMap.values());
  groups.sort((groupA, groupB) => sortCollectionItems(groupA.group, groupB.group));
  groups.forEach((group) => {
    group.options.sort(sortCollectionItems);
  });
  const displayGroups = groups.map(({ group, options: options2 }) => {
    return {
      id: group.id,
      title: group.displayName || group.alternateName || group.name,
      items: options2.map(({ id, displayName, alternateName, name }) => ({
        key: id,
        label: displayName || alternateName || name
      }))
    };
  });
  return displayGroups;
}
export {
  formatEquipmentGroups
};
